function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5580_7810)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5 46.5V28.5",
  stroke: "#1B75BB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 36L24.5 28.5L32 36",
  stroke: "#1B75BB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.0007 31.4986H37.2507C38.7804 31.5012 40.2892 31.1438 41.6552 30.4554C43.0213 29.7669 44.2061 28.7667 45.1141 27.5356C46.022 26.3045 46.6275 24.877 46.8817 23.3686C47.1359 21.8602 47.0315 20.3131 46.5771 18.8524C46.1227 17.3918 45.3311 16.0585 44.266 14.9605C43.201 13.8624 41.8926 13.0304 40.4465 12.5315C39.0004 12.0327 37.4573 11.8812 35.9418 12.0891C34.4263 12.2971 32.981 12.8587 31.7227 13.7286C31.2204 11.0546 30.0003 8.56746 28.193 6.53365C26.3856 4.49983 24.0592 2.9959 21.4627 2.18288C18.8662 1.36987 16.0974 1.27839 13.4529 1.91825C10.8084 2.55811 8.38772 3.9052 6.45009 5.81528C4.51245 7.72536 3.13083 10.1265 2.45317 12.7616C1.77551 15.3966 1.82733 18.1664 2.60307 20.7743C3.37882 23.3822 4.84929 25.73 6.85701 27.5662C8.86473 29.4025 11.3341 30.6581 14.0007 31.1986",
  stroke: "#1B75BB",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5580_7810"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(0.5)"
})));

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.46d2a95c.svg";
export { ForwardRef as ReactComponent };